import React, { useEffect, useState } from "react";
import { Container, Grid, Button, TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody, TablePagination, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, TextField, IconButton, Checkbox, } from "@mui/material";
import { Add, Edit, Delete, Save, Cancel, Slideshow, Check, } from "@mui/icons-material";
const GenericTable = ({ data, columns, onAdd, onEdit, onDelete, initialItem, readonly, onRowClick, }) => {
    const [openAddModal, setOpenAddModal] = useState(false);
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
    const [openSaveDialog, setOpenSaveDialog] = useState(false);
    const [currentItem, setCurrentItem] = useState(null);
    const [newItem, setNewItem] = useState(initialItem);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [sortField, setSortField] = useState(null);
    const [sortOrder, setSortOrder] = useState("asc");
    const handleChangePage = (event, newPage) => {
        if (data.length === 0) {
            setPage(0);
        }
        else {
            setPage(newPage);
        }
    };
    useEffect(() => {
        if (data.length === 0) {
            setPage(0);
        }
    }, [data, page]);
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    const handleAdd = () => {
        onAdd(newItem);
        setNewItem(initialItem);
        setOpenAddModal(false);
    };
    const handleEdit = (item) => {
        onEdit(item);
        setCurrentItem(null);
    };
    const handleDelete = () => {
        if (currentItem) {
            onDelete(currentItem);
            setCurrentItem(null);
            setOpenDeleteDialog(false);
        }
    };
    const handleCancelEdit = () => {
        setCurrentItem(null);
    };
    const confirmSave = () => {
        if (currentItem) {
            onEdit(currentItem);
            setCurrentItem(null);
            setOpenSaveDialog(false);
        }
    };
    const handleSort = (field) => {
        const isAsc = sortField === field && sortOrder === "asc";
        setSortOrder(isAsc ? "desc" : "asc");
        setSortField(field);
    };
    const handleRowClick = (ID) => {
        //call the handleRowClick function from the parent component
        if (onRowClick) {
            onRowClick(ID);
        }
    };
    const getCurrentPage = () => {
        const totalPages = Math.ceil(data.length / rowsPerPage);
        if (page >= totalPages) {
            setPage(0);
            return 0;
        }
        else {
            return page;
        }
    };
    const sortedData = React.useMemo(() => {
        if (data.length === 0) {
            setPage(0);
        }
        if (!sortField)
            return data;
        return [...data].sort((a, b) => {
            if (a[sortField] < b[sortField])
                return sortOrder === "asc" ? -1 : 1;
            if (a[sortField] > b[sortField])
                return sortOrder === "asc" ? 1 : -1;
            return 0;
        });
    }, [data, sortField, sortOrder]);
    const paginatedData = React.useMemo(() => {
        if (sortedData.length === 0) {
            setPage(0);
        }
        return sortedData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
    }, [sortedData, page, rowsPerPage]);
    return (React.createElement(Container, { maxWidth: false, sx: {
            width: "100%",
            margin: "15px 0px 0px 0px !important",
            padding: "0px !important",
        } },
        React.createElement(Grid, { container: true, spacing: 2 },
            React.createElement(Grid, { item: true, md: 2, xs: 12 }, !readonly && (React.createElement(Button, { variant: "contained", color: "primary", startIcon: React.createElement(Add, null), onClick: () => setOpenAddModal(true), sx: { margin: "0px 0px 15px 0px" } }, "Add New"))),
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(TableContainer, { component: Paper },
                    React.createElement(Table, null,
                        React.createElement(TableHead, null,
                            React.createElement(TableRow, { sx: { "& th": { padding: "5px 8px" } } },
                                columns.map((column, index) => (React.createElement(TableCell, { key: `${index}-${String(column.field)}`, onClick: () => handleSort(column.field), sx: { cursor: "pointer" } },
                                    column.headerName,
                                    sortField === column.field
                                        ? sortOrder === "asc"
                                            ? " ▲"
                                            : " ▼"
                                        : ""))),
                                React.createElement(TableCell, null, "View"),
                                !readonly && (React.createElement(TableCell, { sx: {
                                        textAlign: "right",
                                        display: "flex",
                                        justifyContent: "flex-end",
                                    } }, "Actions")))),
                        React.createElement(TableBody, null, paginatedData.map((item, rowIndex) => (React.createElement(TableRow, { key: `${item.ID}-rowIndex-${rowIndex}`, sx: {
                                "& td": {
                                    padding: "2px 5px !important",
                                    // Add cursor pointer if onRowClick is defined
                                    //cursor: onRowClick ? "pointer" : "default",
                                },
                            } },
                            columns.map((column) => {
                                var _a;
                                return (React.createElement(TableCell, { key: `${item.ID}-${String(column.field)}`, sx: {} }, currentItem && currentItem.ID === item.ID ? (React.createElement(TextField, { value: column.dataType && column.dataType === "boolean"
                                        ? ""
                                        : currentItem[column.field], onChange: (e) => setCurrentItem(Object.assign(Object.assign({}, currentItem), { [column.field]: e.target.value })) })) : column.dataType && column.dataType === "boolean" ? (React.createElement(Checkbox, { checked: item[column.field], checkedIcon: React.createElement(Check, null), disabled: true })) : (
                                // not a boolean data type
                                String((_a = item[column.field]) !== null && _a !== void 0 ? _a : ""))));
                            }),
                            React.createElement(TableCell, { sx: {} },
                                React.createElement(IconButton, { sx: { padding: "2px !important" }, color: "primary", onClick: () => handleRowClick(item.ID) },
                                    React.createElement(Slideshow, { sx: { fontSize: "1.7em" } }))),
                            !readonly && (React.createElement(TableCell, { sx: {
                                    textAlign: "right",
                                    display: "flex",
                                    justifyContent: "flex-end",
                                } }, currentItem && currentItem.ID === item.ID ? (React.createElement(React.Fragment, null,
                                React.createElement(IconButton, { color: "primary", onClick: () => handleEdit(currentItem) },
                                    React.createElement(Save, null)),
                                React.createElement(IconButton, { color: "primary", onClick: handleCancelEdit },
                                    React.createElement(Cancel, null)))) : (React.createElement(React.Fragment, null,
                                React.createElement(IconButton, { color: "primary", onClick: () => setCurrentItem(item) },
                                    React.createElement(Edit, null)),
                                React.createElement(IconButton, { color: "primary", onClick: () => {
                                        setCurrentItem(item);
                                        setOpenDeleteDialog(true);
                                    } },
                                    React.createElement(Delete, null)))))))))))),
                React.createElement(TablePagination, { rowsPerPageOptions: [5, 10, 25, 50, 100], component: "div", count: sortedData.length, rowsPerPage: rowsPerPage, page: data.length === 0 ? 0 : getCurrentPage(), onPageChange: handleChangePage, onRowsPerPageChange: handleChangeRowsPerPage }))),
        React.createElement(Dialog, { open: openAddModal, onClose: () => setOpenAddModal(false) },
            React.createElement(DialogTitle, null, "Add New Item"),
            React.createElement(DialogContent, null, columns.map((column) => (React.createElement(TextField, { key: String(column.field), margin: "dense", label: column.headerName, fullWidth: true, value: newItem[column.field], onChange: (e) => setNewItem(Object.assign(Object.assign({}, newItem), { [column.field]: e.target.value })) })))),
            React.createElement(DialogActions, null,
                React.createElement(Button, { onClick: () => setOpenAddModal(false), color: "primary" }, "Cancel"),
                React.createElement(Button, { onClick: handleAdd, color: "primary" }, "Add"))),
        React.createElement(Dialog, { open: openDeleteDialog, onClose: () => setOpenDeleteDialog(false) },
            React.createElement(DialogTitle, null, "Delete Item"),
            React.createElement(DialogContent, null,
                React.createElement(DialogContentText, null, "Are you sure you want to delete this item?")),
            React.createElement(DialogActions, null,
                React.createElement(Button, { onClick: () => setOpenDeleteDialog(false), color: "primary" }, "Cancel"),
                React.createElement(Button, { onClick: handleDelete, color: "primary" }, "Delete"))),
        React.createElement(Dialog, { open: openSaveDialog, onClose: () => setOpenSaveDialog(false) },
            React.createElement(DialogTitle, null, "Save Changes"),
            React.createElement(DialogContent, null,
                React.createElement(DialogContentText, null, "Are you sure you want to save the changes?")),
            React.createElement(DialogActions, null,
                React.createElement(Button, { onClick: () => setOpenSaveDialog(false), color: "primary" }, "Cancel"),
                React.createElement(Button, { onClick: confirmSave, color: "primary" }, "Save")))));
};
export default GenericTable;
